import React from 'react'

import DOMPurify from 'dompurify'

import EmptyText from './EmptyText'

export default ({ children, multiLine }) => {
  if (multiLine && typeof children === 'string') {
    const hasContent = Boolean(children.replace(/<[^>]*>/g, '').trim())
    return (
      <div className="form-text">
        {hasContent ? <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(children) }} /> : <EmptyText />}
      </div>
    )
  }

  return <div className="form-text">{children || <EmptyText />}</div>
}
